// Sugalarm — cycle 67: dev-injection feature-flag probe.
//
// Polls /api/health once on mount, reads `dev_inject_enabled`, and
// returns the boolean. Default `false`; flips true only when the
// server explicitly says so (production never does — the env flag is
// unset). The SPA mounts `<AlarmTestConsole>` only when this returns
// true, so the dev console can never appear on a production build.
//
// `/api/health` is unauthenticated and stable; we don't poll on an
// interval — restart-and-resign is fine.

import { useEffect, useState } from "react";

import { apiUrl } from "../env";

export function useDevInjectEnabled(): boolean {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(apiUrl("/api/health"), { cache: "no-store" });
        if (!res.ok) return;
        const data = (await res.json()) as { dev_inject_enabled?: boolean };
        if (cancelled) return;
        setEnabled(data?.dev_inject_enabled === true);
      } catch {
        // Network blip — stay disabled, indistinguishable from "flag off".
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return enabled;
}
